import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles'
import * as styles from './_SidebarContent.scss'
import React from 'react'
import FontAwesome from 'react-fontawesome'
import { Nav, Row, Col, Container } from 'react-bootstrap'
import isEmpty from 'lodash/fp/isEmpty'
import 'bootstrap/dist/css/bootstrap.min.css';

const SidebarContent = ({
  navigationLinksFetched,
  audiences,
  searchPage,
  contactPage,
  investPage,
  signIn,
  mainMenu,
  publicPortalUrl,
  activeMenu,
  setActiveMenu
}) => (
  <Container className={styles['grid']} >
    {navigationLinksFetched && !isEmpty(mainMenu) && <Row>
      <Col xs={12} className={styles['no-padding']}>
        <Nav variant='pills' className="flex-column">
          {mainMenu.map((menuItem, index) => {
            return <div key={index} className={index === 0 ? styles['first-sidebar-link-group'] : null}>
              <div className={styles['sidebar-link-group']}>
                <Nav.Item
                  onClick={() => setActiveMenu(menuItem.Name)}
                  className={styles['sidebar-link-group-title']} >
                  {menuItem.Name}
                  <FontAwesome name={activeMenu === menuItem.Name ? 'chevron-up' : 'chevron-down'} />
                </Nav.Item>
              </div>
              {activeMenu !== menuItem.Name && <hr className={styles['sidebar-line']} />}
              {activeMenu === menuItem.Name && <ul>
                {!isEmpty(menuItem.Columns) && menuItem.Columns.map((column, columnIndex) => {
                  return <div key={columnIndex}>
                    {!column.HideTitle && <h4 className={styles['sidebar-link-group-sub-menu-title']}>{column.Name}</h4>}
                    {!isEmpty(column.Links) && column.Links.map((columnLink, columnLinkIndex) => {
                      return <a key={columnLinkIndex}
                        href={`${publicPortalUrl}${columnLink.Link.replace('https://www.allangray.co.za', '')}`}
                        className={styles['sidebar-link'] + ' ' + styles['sidebar-link-initial-text']}>
                        {columnLink.Name}
                      </a>
                    })}
                    <hr className={styles['sidebar-line']} />
                  </div>
                })}
              </ul>
              }
            </div>
          })}
          <a
            href={`${investPage.Link}`}
            className={styles['sidebar-link']}>
            Invest Now
            <FontAwesome name={'play-circle-o'} size={'lg'} />
          </a>
          <a
            href={`${publicPortalUrl}${searchPage.Link}`}
            className={styles['sidebar-link']}>
            Search
             <FontAwesome name={'search'} size={'lg'} />
          </a>
          <a
            href={`${publicPortalUrl}${contactPage.Link}`}
            className={styles['sidebar-link']}>
            Contact
             <FontAwesome name={'phone'} size={'lg'} />
          </a>
          <a
            href={`${signIn.Link}`}
            className={styles['sidebar-link']}>
            Log In
             <FontAwesome name={'lock'} size={'lg'} />
          </a>
          <hr className={styles['sidebar-line']} />
          {!isEmpty(audiences) && audiences.map((audience, index) => {
            return <a
              key={index}
              href={`${publicPortalUrl}${audience.Link}`}
              className={styles['sidebar-link']}>{audience.Name}</a>
          })}
        </Nav>
      </Col>
    </Row>}
  </Container>
  )

SidebarContent.propTypes = {
  activeMenu: PropTypes.string,
  publicPortalUrl: PropTypes.string.isRequired,
  navigationLinksFetched: PropTypes.bool.isRequired,
  audiences: PropTypes.array,
  searchPage: PropTypes.object,
  contactPage: PropTypes.object,
  investPage: PropTypes.object,
  signIn: PropTypes.object,
  mainMenu: PropTypes.array,
  setActiveMenu: PropTypes.func.isRequired
}

export default (SidebarContent)
